

const Layout2Settings = {
  leftSidebar: {
    show: false,
    mode: "close", // full, close, compact, mobile
    theme: "slateDark1", // Use a valid theme from MatxTheme/themeColors.js
    bgImgURL: "/assets/images/sidebar/sidebar-bg-dark.jpg"
  },
  topbar: {
    show: true,
    fixed: true,
    theme: "whiteBlue" // Use a valid theme from MatxTheme/themeColors.js
  }
};

export default Layout2Settings;